import axios from 'axios';

export default {
  toggleDrawer({
    commit,
  }) {
    commit('toggleDrawer');
  },
  fetchLookupData(_, params) {
    return axios.get('/lookup', {
      params,
    });
  },
  login(_, credentials) {
    return axios.post('/login', credentials);
  },
  hideSnackbar({
    commit,
  }) {
    commit('setSnackbarProps', {
      show: false,
    });
  },
  showSuccessSnackbar({
    commit,
  }, text) {
    commit('setSnackbarProps', {
      text,
      color: 'success',
    });
  },
  showErrorSnackbar({
    commit,
  }, text) {
    commit('setSnackbarProps', {
      text,
      color: 'error',
    });
  },
  setCurrentUser({ commit }, username) {
    commit('setCurrentUser', username);
  },
  showInfoSnackbar({
    commit,
  }, text) {
    commit('setSnackbarProps', {
      text,
      color: 'info',
    });
  },
};
